import {
  container,
  title,
  cardTitle,
  main,
  mainRaised,
  mrAuto,
  whiteColor,
  grayColor,
  mlAuto,
  secondaryDarkColor
} from "assets/jss/material-kit-pro-react.js";

import buttonGroup from "assets/jss/material-kit-pro-react/buttonGroupStyle.js";
import tooltips from "assets/jss/material-kit-pro-react/tooltipsStyle.js";

const styles = {
  main,
  mainRaised,
  mrAuto,
  mlAuto,
  ...buttonGroup,
  ...tooltips,
  container: {
    ...container,
    zIndex: 1
  },
  title: {
    ...title
  },
  block: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block"
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto"
  },
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  left: {
    float: "left!important",
    display: "block"
  },
  right: {
    padding: "15px 0",
    margin: "0",
    float: "right"
  },
  icon: {
    width: "18px",
    height: "18px",
    top: "3px",
    position: "relative"
  },
  imgContainer: {
    width: "120px",
    maxHeight: "160px",
    overflow: "hidden",
    display: "block",
    "& img": {
      width: "100%"
    }
  },
  description: {
    maxWidth: "150px"
  },
  tdName: {
    minWidth: "200px",
    fontWeight: "400",
    fontSize: "1.5em"
  },
  tdNameAnchor: {
    color: grayColor[1]
  },
  tdNameSmall: {
    color: grayColor[0],
    fontSize: "0.75em",
    fontWeight: "300"
  },
  tdNumber: {
    textAlign: "right",
    minWidth: "150px",
    fontWeight: "300",
    fontSize: "1.125em !important"
  },
  tdNumberSmall: {
    marginRight: "3px"
  },
  tdNumberAndButtonGroup: {
    lineHeight: "1 !important",
    "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
      marginRight: "0"
    }
  },
  customFont: {
    fontSize: "16px !important"
  },
  actionButton: {
    margin: "0px",
    padding: "5px"
  },
  textCenter: {
    textAlign: "center"
  },
  textRight: {
    textAlign: "right"
  },
  cardTitle: {
    ...cardTitle,
    textAlign: "center",
    marginTop: "0 !important",
    marginBottom: "0 !important",
    textTransform: "uppercase"
  },
  appBar: {
    backgroundColor: whiteColor,
    boxShadow: "none"
  },
  divBadge: {
    top: "25px",
    right: "25px",
    borderRadius: "0",
    backgroundColor: "red",
    color: whiteColor
  },
  strike: {
    textDecoration: "line-through",
    marginRight: "15px"
  },
  padding0: {
    padding: "0px !important"
  },
  pricingCardCategory: {
    padding: "15px 0px",
    background: "#006978",
    color: whiteColor,
    fontSize: "0.9rem",
    marginBottom: "0px",
    marginTop: "0px"
  },
  pricingCardTitle: {
    backgroundColor: "#006978",
    color: whiteColor,
    paddingBottom: 10,
    fontSize: "2rem"
  },
  iconColor: {
    color: whiteColor
  },
  cardMainTitle: {
    fontSize: "1.5rem",
    marginTop: "4rem !important"
  },
  marginTab: {
    marginTop: "5rem"
  },
  indicatorColor: {
    backgroundColor: secondaryDarkColor
  },
  selectedTab: {
    color: secondaryDarkColor + "!important",
    "& span": {
      fontWeight: "700"
    }
  },
  subscriptionCardHeader: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#006978",
    marginBottom: "30px"
  },
  successfulOrder: {
    textAlign: "center",
    "& img": {
      width: 200
    },
    "& h2": {
      marginTop: 50
    },
    "& button": {
      marginTop: 50,
      fontSize: "1rem"
    }
  },
  orderPageDiv: {
    minHeight: "70vh",
    backgroundColor: whiteColor
  },
  orderCard: {
    paddingTop: 100,
    paddingBottom: 50 
  },
  tabRoot: {
    "@media (max-width: 768px)": {
      padding: 10
    }
  }
};

export default styles;
